import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import "../../../Myaccount/Myaccount.css";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { useTranslation } from "react-i18next";
import React from "react";

import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { TableBody } from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.action.hover,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

// const columns = [
//   "General Safety / Safety Performance",
//   "Adherence to Site Safety Rules",
//   "Use of Proper PPE",
//   "Housekeeping",
//   "Self-Audit Quality / Frequency",
//   "Communication, Responsiveness and Organization",
//   "General Attitude",
//   "Job Knowledge & Problem Solving",
//   "Equipment",
//   "Key Field Personnel",
//   "Execution of Work",
//   "Quality of Craft Work",
//   "Project Manager",
//   "Cost Within Expectation",
//   "Schedule",
//   "Timeliness of Work",
//   "Labor Relations",
//   "Time and Material Reporting",
//   "Environment",
//   "Compliance",
// ];


export default function ProjectEvaluationSection2(props) {
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = React.useState();

  const Radiobuttonchange = (event) => {
    setSelectedValue(event.target.value);
  };
  return (
    <>
      <Box className="mt-3" hidden={!props}>
        <TableContainer component={Paper} className="mb-3">
          <h5 className="mx-3 my-3" variant="contained">
            {t("ProjectEvalution.Section")}
          </h5>

          <span className="mx-3" style={{ color: "#667085" }}>
          {t("ProjectEvalution.label")} <span style={{ color: "#2A93DB" }}>{t("ProjectEvalution.label1")}</span>
          </span>
          <Box
            className="mx-2"
            sx={{ width: "auto", backgroundColor: "#F9FAFB", padding: "12px" }}
          >
             {t("ProjectEvalution.label2")}
          </Box>
          <Table aria-label="customized table">
            <TableBody>
              {props?.data?.map((r, index) => (
                <TableRow key={index}>
                  <StyledTableCell sx={{ width: "25%" }}>{r?.questionString}</StyledTableCell>
                  <StyledTableCell sx={{ width: "17%" }} >

                    <FormControlLabel
                      control={
                        <Radio
                          checked={r?.rating === 0}
                          onChange={Radiobuttonchange}
                          value={r?.rating}
                          disabled
                          size="small"
                        />
                      }
                      label={t("ProjectEvalution.Radiobutton1")}
                    />
                  </StyledTableCell>
                  <StyledTableCell sx={{ width: "20%" }}>
                    <FormControlLabel
                      control={<Radio
                        checked={r?.rating === 1}
                        onChange={Radiobuttonchange}
                        value={r?.rating}
                        disabled
                        size="small"
                      />}
                      label={t("ProjectEvalution.Radiobutton2")}

                    />
                  </StyledTableCell>
                  <StyledTableCell sx={{ width: "20%" }}>
                    <FormControlLabel
                      control={<Radio
                        checked={r?.rating === 2}
                        onChange={Radiobuttonchange}
                        value={r?.rating}
                        disabled
                        size="small"
                      />}
                      label={t("ProjectEvalution.Radiobutton3")}
                    />
                  </StyledTableCell>
                  <StyledTableCell sx={{ width: "35%" }} align="left">
                    <FormControlLabel
                      control={<Radio
                        checked={r?.rating === 3}
                        onChange={Radiobuttonchange}
                        value={r?.rating}
                        disabled
                        size="small"
                      />}
                      label={t("ProjectEvalution.Radiobutton4")}
                    />
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {/* <div className='text-right mt-3 mb-3' style={{ marginRight: "35px" }}>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ textTransform: "capitalize",padding:"15px" }}
                            onClick={() => alert("Save")}
                        >
                            {t("RolesAdmin.save")}
                        </Button>
                    </div> */}
        </TableContainer>
      </Box>
    </>
  );
}
